import { agruparRetorno } from '@/utils/agruparRetorno';
import { IGerarRetornoSicredi, IDocumentoRetornoSicredi } from './types';
import { parse } from 'date-fns';

enum Registro {
  HEADER = '0',
  DETALHE = '1',
  TRAILER = '9',
}

export function gerarRetorno({ dados }: IGerarRetornoSicredi) {
  try {
    const { arquivo } = dados;
    const documentos: IDocumentoRetornoSicredi[] = [];

    for (const linha of arquivo) {
      const id_registro = linha.substring(0, 1);

      if (id_registro !== Registro.DETALHE) {
        continue;
      }

      const ocorrencia = linha.substring(108, 110);

      if (ocorrencia !== '06' && ocorrencia !== '15' && ocorrencia !== '17') {
        continue;
      }

      const meu_numero = linha.substring(116, 126).trim();
      let tipo_documento: string = '';
      let id_documento: string = '';

      if (meu_numero.includes('-')) {
        const [tipo, id] = meu_numero.split('-');
        tipo_documento = tipo;
        id_documento = id;
      }

      let especie = 'INDEFINIDO';
      if (tipo_documento.length) {
        especie =
          tipo_documento === 'N' ? 'NFE' :
          tipo_documento === 'F' ? 'FAT' :
          tipo_documento === 'L' ? 'FIN' :
          'INDEFINIDO';
      }

      let dataCredito: Date;
      // Data de crédito no formato AAAAMMDD
      const dataCreditoString = linha.substring(328, 336);
      if (dataCreditoString && dataCreditoString !== '00000000') {
        dataCredito = parse(dataCreditoString, 'yyyyMMdd', new Date());
      } else {
        // Data de ocorrência no formato DDMMAA
        const dataOcorrenciaString = linha.substring(110, 116);
        dataCredito = parse(dataOcorrenciaString, 'ddMMyy', new Date());
      }

      const valor_titulo = Number(linha.substring(152, 165)) / 100;
      const abatimento = Number(linha.substring(227, 240)) / 100;
      let valor_desconto = Number(linha.substring(240, 253)) / 100;
      const valor_pago = Number(linha.substring(253, 266)) / 100;
      let valor_juros = Number(linha.substring(266, 279)) / 100;
      const valor_multa = Number(linha.substring(279, 292)) / 100;

      if (valor_titulo > valor_pago && valor_desconto === 0) {
        valor_desconto = valor_titulo - valor_pago;
      }

      if (valor_titulo < valor_pago && valor_juros === 0) {
        valor_juros = valor_pago - valor_titulo;
      }

      const descontos = abatimento + valor_desconto;
      const valor_total = valor_titulo + valor_multa + valor_juros - descontos;

      documentos.push({
        id_documento,
        especie,
        valor: valor_pago,
        valor_multa,
        valor_juros,
        valor_desconto,
        valor_total,
        data: dataCredito
      });
    }

    const documentosAgrupado = agruparRetorno<IDocumentoRetornoSicredi>(documentos);
    return documentosAgrupado;
  } catch (error) {
    console.log(error);
    return null;
  }
}
